import jwtDecode from 'jwt-decode';

const mutations = {
  setAllRoles(state, roles) {
    state.allRoles = roles;
  },
  setToken(state, token) {
    state.token = token;
  },
  setUsuario(state, name) {
    state.name = name;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setTenantIds(state, tenantIds) {
    state.tenantIds = tenantIds || [];
  },
  setTenantId(state, tenantId) {
    state.tenantId = tenantId;
  },
  setTipoAuth(state, iss) {
    if (iss.includes('id.magalu.com') || iss.includes('autoseg-idp')) {
      state.tipoAuth = 'idMagalu';
    } else {
      state.tipoAuth = 'ssoCorp';
    }
  },
};

const actions = {
  setToken({ commit }, token) {
    if (!token) {
      return;
    }
    commit('setToken', token);
    const decoded = jwtDecode(token),
      { name, email, iss } = decoded;

    commit('setUsuario', name);
    commit('setEmail', email);
    commit('setTipoAuth', iss);
  },
  setTenantId({ commit }, tenantId) {
    commit('setTenantId', tenantId);
  },
  settarTodasRoles({ commit }, roles) {
    commit('setAllRoles', roles);
  },
  carregarTenantIds({ commit }, resource) {
    return new Promise((resolve, reject) => {
      resource().then((response) => {
        const tenantIds = response.data.tenant || [];
        tenantIds.sort((a, b) => a.localeCompare(b));
        commit('setTenantIds', tenantIds);
        resolve();
      }).catch(reject);
    });
  },
};

const getters = {
  getAllRoles(state) {
    return state.allRoles;
  },
  getRoles(state) {
    return state.roles;
  },
  getToken(state) {
    return state.token;
  },
  getUsuario(state) {
    return state.name;
  },
  getTenantIds(state) {
    return state.tenantIds;
  },
  getTenantId(state) {
    return state.tenantId;
  },
  getTipoAuth(state) {
    return state.tipoAuth;
  },
};

const state = {
  access: {},
  allRoles: [],
  roles: [],
  token: null,
  name: '',
  tenantIds: [],
  tenantId: null,
  tipoAuth: '',
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
